import React from 'react';
import PropTypes from 'prop-types';
import './css/FlightOption.css';
import { formatPrice } from '../../Utils/CommonUtils';
import {
  getForwardDepartureTime,
  getForwardDepartureDate,
  getForwardDepartureAirportId,
  getForwardArrivalTime,
  getForwardArrivalAirportId,
  getForwardTotalTripTime,
  getForwardCompaniesWithFlightId,
  getBackwardDepartureTime,
  getBackwardDepartureDate,
  getBackwardDepartureAirportId,
  getBackwardArrivalTime,
  getBackwardArrivalAirportId,
  getBackwardTotalTripTime,
  getBackwardCompaniesWithFlightId,
  getTripTransferSummary,
} from '../../Utils/FlightUtils';
import {
  TO,
  BACK,
  IN_TRIP,
  SLECT,
  SELECTED,
  CHEAPEST,
  DIRECT,
  TRANSFER,
} from '../../Utils/Constants/GlobalConstants';
import PriceText from '../PriceText/PriceText';

// one flight option in a compact row per direction: admin and the cabinet
function FlightOption(props) {
  const { flight, cheapestPrice, isSelected, cheapest, handleSelect } = props;
  const { currency, value } = flight.price;

  const getAddPay = () => {
    const dif = Math.ceil(value - cheapestPrice);

    return dif > 0 ? `+ ${formatPrice(dif)} ${currency}` : '';
  };

  const getTransferText = (segments) =>
    (segments.length > 1
      ? `${TRANSFER} ${getTripTransferSummary(segments)}`
      : DIRECT);

  const getNumbersText = (companies) =>
    companies.map((item) => item.number).join(', ');

  const renderDirection = (title, segments, data) => (
    <div className="fo_direction">
      <div className="gr_text_13 fo_direction_title">{title}</div>
      <div>
        <div className="bm_text_14">
          {`${data.departureTime} ${data.departureAirport} → ${data.arrivalTime} ${data.arrivalAirport}`}
        </div>
        <div className="gr_text_13">
          {[
            data.departureDate,
            `${IN_TRIP}: ${data.tripTime}`,
            getTransferText(segments),
            getNumbersText(data.companies),
          ]
            .filter((item) => item)
            .join(' · ')}
        </div>
      </div>
    </div>
  );

  const hasBackward = flight.backward && flight.backward.length > 0;

  return (
    <div className={`fo_option ${isSelected ? 'fo_option_selected' : ''}`}>
      <div className="fo_head">
        <div className="fo_price">
          <span className="bb_text_18">
            <PriceText text={`${formatPrice(value)} ${currency}`} />
          </span>
          <span className="rr_text_14">
            <PriceText text={getAddPay()} />
          </span>
          {cheapest && (
            <span className="fo_cheapest wr_text_12">{CHEAPEST}</span>
          )}
        </div>
        <button
          type="button"
          className={`fo_select_btn bm_text_14 ${
            isSelected ? 'light_gray_button' : 'btn__yellow'
          }`}
          disabled={isSelected}
          onClick={() => handleSelect(flight)}
        >
          {isSelected ? SELECTED : SLECT}
        </button>
      </div>
      {renderDirection(TO, flight.forward || [], {
        departureTime: getForwardDepartureTime(flight),
        departureAirport: getForwardDepartureAirportId(flight),
        departureDate: getForwardDepartureDate(flight),
        arrivalTime: getForwardArrivalTime(flight),
        arrivalAirport: getForwardArrivalAirportId(flight),
        tripTime: getForwardTotalTripTime(flight),
        companies: getForwardCompaniesWithFlightId(flight),
      })}
      {hasBackward &&
        renderDirection(BACK, flight.backward, {
          departureTime: getBackwardDepartureTime(flight),
          departureAirport: getBackwardDepartureAirportId(flight),
          departureDate: getBackwardDepartureDate(flight),
          arrivalTime: getBackwardArrivalTime(flight),
          arrivalAirport: getBackwardArrivalAirportId(flight),
          tripTime: getBackwardTotalTripTime(flight),
          companies: getBackwardCompaniesWithFlightId(flight),
        })}
    </div>
  );
}

FlightOption.propTypes = {
  flight: PropTypes.instanceOf(Object).isRequired,
  cheapestPrice: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  cheapest: PropTypes.bool.isRequired,
  handleSelect: PropTypes.func.isRequired,
};

export default FlightOption;
